import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { InfoTooltipComponent } from '../info-tooltip.component';

@Component({
  selector: 'formly-field-week-time',
  template: `
    <div class="formly-field-week-time">
      <h3 class="mb-2">
        {{ props.label }}
        <app-info-tooltip [tooltip]="props.info"></app-info-tooltip>
      </h3>
      <div class="flex w-full flex-col">
        @for (subField of field.fieldGroup; track $index) {
          <formly-field [field]="subField" [class]="subField.className" [formlyAttributes]="subField"></formly-field>
        }
      </div>
      @if (field.props.description) {
        <mat-hint class="inline-block mb-2">{{ field.props.description }}</mat-hint>
      }
    </div>
  `,
  imports: [
    ReactiveFormsModule,
    MatAutocompleteModule,
    FormlyModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    InfoTooltipComponent,
  ],
  styles: `
    :host formly-field h3 {
      display: none;
    }

    ::ng-deep #top .checkbox-flex mat-checkbox {
      width: 100% !important;
    }

    ::ng-deep #top .formly-field-week-time .mat-mdc-form-field-type-checkbox .mat-mdc-form-field-flex {
      padding-left: 0 !important;
    }

    ::ng-deep #top .formly-field-week-time .mat-mdc-form-field-subscript-wrapper {
      display: none !important;
    }

    ::ng-deep #top .border-none .mat-mdc-text-field-wrapper {
      border: none !important;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldWeekTime extends FieldType implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {
    this.field.fieldGroup = this.field.fieldGroup.map(subField => {
      subField.props.label = '';
      return subField;
    });
  }
}
